import React, { useRef, useState, useEffect } from 'react';
import CountUp from 'react-countup';

const CountUpOnScroll = ({ end }) => {
  const countUpRef = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          observer.disconnect();
        }
      },
      {
        threshold: 0.5, // Adjust this threshold as needed
      }
    );

    if (countUpRef.current) {
      observer.observe(countUpRef.current);
    }

    return () => {
      if (countUpRef.current) {
        observer.unobserve(countUpRef.current);
      }
    };
  }, []);

  return (
    <div ref={countUpRef}>
      {inView ? <CountUp end={end} duration={2} /> : null}
    </div>
  );
};

export default CountUpOnScroll;